module.exports = __webpack_public_path__ + "assets/img/chapter.2769e5bc.png";